export default {
  appLoginTitle: 'RIESKO RMG',
  errors: {
    '1': 'Nome utente o password errati',
    '2': 'Utenza bloccata',
    '3': 'Nessuna istanza collegata la tuo account',
    generic: 'Si è verificato un erorre imprevisto',
    unauthorized: {
      title: 'Non autorizzato',
      message: 'Non hai i permessi per accedere a questa risorsa'
    }
  },
  general: {
    save: 'Salva',
    submit: 'Salva ed invia',
    delete: 'Elimina',
    cancel: 'Annulla',
    edit: 'Modifica',
    readOnly: 'Salva e apri in sola lettura',
    exit: 'Esci',
    saved: 'Salvataggio effettuato',
    'save-notification': 'Dati salvati correttamente',
    deleted: 'Eliminato',
    'delete-notification': 'Elemento eliminato correttamente',
    print: 'Stampa',
    import: 'Import',
    'change-state': 'Cambia stato',
    'change-state-question': 'Sei sicuro di voler cambiare lo stato di ',
    allFieldsAreRequired: 'Tutti i campi sono obbligatori',
    questionDelete: 'Sei sicuro di voler eliminare l\'elemento "NAME"?',
    noName: '-',
    elementiPerPagina: 'Elementi per pagina',
    typeToSearch: 'Digita per cercare',
    copyright: 'Riesko © 2023 Tutti i diritti sono riservati.'
  },
  user: {
    'login-title': 'Accedi al sistema',
    'username-required': 'Nome utente richiesto',
    'password-required': 'Password richiesta',
    register: 'Registrazione',
    'forgot-password': 'Password dimenticata',
    email: 'E-mail',
    password: 'Password',
    'password-again': 'Password Again',
    'forgot-password-question': 'Password dimenticata?',
    fullname: 'Full Name',
    'login-button': 'Accedi',
    'register-button': 'Register',
    'reset-password-button': 'Reset',
    username: 'Nome utente',
    code: 'Reset Code',
    settings: 'Impostazioni',
    logout: 'Esci',
    login: 'Inserisci le credenziali per autenticarti. Se non sei un membro, procedi la ',
    wrongCredentials: 'Nome utente o password errati'
  },
  menu: {
    enterprises: 'Fornitori',
    resources: 'Risorse',
    language: 'Lingua',
    app: 'Home',
    start: 'Start',
    home: 'Home',
    identification: 'Rischi',
    analysis: 'Analisi',
    treatment: 'Trattamenti',
    gross: 'Analisi As Is',
    net: 'Analisi',
    search: 'Cerca',
    filter: 'Filtra',
    login: 'Accedi al sistema',
    register: 'Register',
    'forgot-password': 'Password dimenticata',
    'reset-password': 'Reset Password',
    error: 'Errore',
    menu: 'Menu',
    stats: 'Statistiche',
    admin: 'Amministrazione aziendale',
    budget: 'Valori di bilancio',
    library: 'Impostazioni azienda',
    import: 'Import Rischi',
    dossier: 'Dossier',
    esg: 'Esg',
    dashboard: 'Dashboard',
    planning: 'Procedure di ripristino',
    bia: 'BIA',
    monitor: 'TODO List',
    issue: 'Campagne',
    campaign: 'Campagne'
  },
  states: {
    tutti: 'Tutti',
    nonAnalizzato: 'Non analizzato',
    asIsNonAnalizzato: 'As Is non analizzato',
    proposto: 'Proposto',
    propostoTxt: 'Rischio in proposta, visibile solo a proprietario',
    inApprovazione: 'In approvazione',
    inApprovazioneTxt: 'Rischio in approvazione nella organizzazione',
    working: 'In lavorazione',
    workingTxt: 'Analisi in lavorazione',
    rifiutato: 'Rifiutato',
    rifiutatoTxt: 'Rischio rifiutato',
    rifiutatoTrattamentoTxt: 'Tratttamento rifiutato, costo NON computato, non utilizzabile in Analisi',
    rifiutatoAnalisiTxt: 'Analisi rifiutata',
    attivo: 'Attivo',
    attivoTxt: 'Rischio attivo ed analizzabile',
    attivoTrattamentoTxt: 'Trattamento in uso. Passaggio in automatico, alla attivazione della prima Analisi che lo utilizza',
    attivoAnalisiTxt: 'Analisi corrente per il Rischio',
    nuovo: 'Nuovo',
    nuovoTxt: 'Analisi in bozza, modificabile da tutti e da sottomettere alla approvazione del Risk Manager',
    superato: 'Superato',
    superatoTxt: 'Analisi obsoleta, sostituita da nuova Analisi attiva',
    bozza: 'Bozza',
    bozzaTxt: 'Bozza trattamento, modificabile. Costo NON computato',
    approvato: 'Approvato',
    approvatoTxt: 'Analisi approvata dal Risk Manager, e da sottomettere alla approvazione del Risk Owner di livello superiore',
    approvatoTrattamentoTxt: 'Trattamento approvato da RM, costo computato, utilizzabile in Analisi',
    scaduto: 'Scaduto',
    scadutoTxt: 'Trattamento scaduto. Passaggio in automatico, alla data di fine. Costo NON computato',
    inattivo: 'Inattivo',
    inattivoTxt: 'Rischio non attivo, non analizzabile',
    compilazione: 'Compilazione',
    compilazioneProcessoTxt: 'Processo in compilazione',
    bozzaProcessoTxt: 'Processo in proposta',
    attivoProcessoTxt: 'Processo attivo'
  },
  analysis: {
    stato: 'Stato',
    rischio: 'Rischio',
    analisi: 'Analisi',
    attivatoIl: 'Attivato il',
    scadeIl: 'Scade il',
    localizzazione: 'Localizzazione',
    valutazione: 'Valutazione',
    azioni: 'Azioni',
    warnings: 'Warnings',
    'causes-tab': {
      cause: 'Causa',
      effect: 'Effetto',
      impact: 'Impatto',
      conseguence: 'Conseguenza',
      probability: 'Probabilità',
      description: 'Descrizione'
    },
    'general-info': 'Informazioni generali',
    'cause-effects': 'Cause Effetti',
    'eval-causes': 'Valutazione cause',
    'eval-effects': 'Valutazione effetti',
    attachments: 'Allegati',
    'popup-title': 'Visualizzazione Analisi',
    bia: 'BIA',
    'general-tab': {
      denomination: 'Denominazione Rischio',
      'risk-code': 'Codice rischio',
      code: 'Codice analisi',
      'ending-date': 'Data scadenza',
      'automatic-calc': 'Calcolo automatico',
      type: 'Tipologia',
      state: 'Stato'
    },
    metriche_impact: 'Metriche: Impatto'
  },
  risks: {
    risk: 'Rischio',
    'button-new-risk': 'Nuova definizione rischio',
    'button-all': 'Tutti',
    'button-proposed': 'Proposto',
    'button-in-approval': 'In approvazione',
    'button-refused': 'Rifiutato',
    'button-active': 'Attivo',
    'button-idle': 'Inattivo',
    'caption-state': 'Stato',
    'caption-category': 'Categoria',
    'caption-typology': 'Tipologia',
    'caption-code': 'Codice',
    'caption-description': 'Descrizione',
    'caption-identification': 'Identificazione',
    'caption-tools': 'Strumenti',
    'popup-title': 'Visualizzazione Rischio',
    'popup-general-info': 'Informazioni Generali',
    'gen-info': {
      state: 'Stato',
      code: 'Codice',
      owner: 'Proprietario',
      'data-identification': 'Data identificazione',
      denomination: 'Denominazione',
      description: 'Descrizione'
    },
    'popup-risk-category': 'Risk Category',
    'risk-cat': {
      category: 'Categoria',
      'macro-description': 'Macro Descrizione',
      description: 'Descrizione',
      'kind-of-risk': 'Tipologia di rischio',
      'nature-of-risk': 'Natura del rischio',
      'origin-of-risk': 'Origine del rischio'
    },
    'popup-cause-effects': 'Cause-Effetti',
    'cause-effects': {
      cause: 'Causa',
      effect: 'Effetto'
    },
    'popup-attachments-list': 'Elenco allegati',
    'popup-links-list': 'Elenco link',
    'popup-evaluated-in': 'Rischio valutato in',
    form: {
      'general-info': 'Informazioni Generali',
      'cause-effects': 'Cause Effetti',
      attachments: 'Allegati',
      state: 'Stato',
      code: 'Codice',
      category: 'Categoria',
      denomination: 'Denominazione',
      description: 'Descrizione',
      'kind-of-risk': 'Tipologia di rischio',
      matrix: 'Matrice,',
      'nature-of-risk': 'Natura del rischio',
      'origin-of-risk': 'Origine dei rischi',
      internal: 'Interno',
      external: 'Esterno'
    }
  },
  supplier: {
    name: 'Nome',
    'fiscal-code': 'Codice fiscale',
    piva: 'Partita Iva',
    www: 'Website',
    nation: 'Nazione',
    province: 'Provincia',
    city: 'Città',
    zip: 'CAP',
    pec: 'Pec',
    address: 'Indirizzo',
    mail: 'E-mail',
    addActivity: 'Aggiungi attività',
    activities: 'Lista delle attività',
    activity: 'Attività',
    details: 'Dettagli',
    close: 'Chiudi'
  },
  treatments: {
    stato: 'Stato',
    rischio: 'Rischio',
    trattamento: 'Trattamento',
    strategia: 'Strategia',
    attivazione: 'Attivazione',
    scadenza: 'Scadenza',
    localizzazione: 'Localizzazione',
    azioni: 'Azioni',
    'states-buttons': {
      draft: 'Bozza',
      approved: 'Approvato',
      active: 'Attivo',
      all: 'Tutti'
    },
    'button-new': 'Nuovo trattamento',
    'select-risk': 'Seleziona un rischio',
    general: 'Generale',
    budget: 'Budget',
    details: 'Dettagli',
    risk: 'Rischio',
    responsable: 'Responsabile',
    'start-date': 'Data stima inizio',
    'end-date': 'Data stima fine',
    price: 'Costo',
    kind: 'Tipo trattamento',
    modality: 'Modalità',
    preventive: 'Preventivo',
    responsive: 'Responsivo',
    code: 'Codice trattamento',
    strategy: 'Strategia',
    priority: 'Priorità',
    advance: 'Avanzamento',
    denomination: 'Denominazione',
    'popup-title': 'Trattamento',
    'general-tab': {
      title: 'Informazioni generali',
      state: 'Stato',
      code: 'Codice',
      priority: 'Priorità',
      advance: 'Avanzamento',
      strategy: 'Strategia',
      modality: 'Modalità',
      denomination: 'Denominazione',
      details: 'Dettaglio trattamento'
    },
    'economics-tab': {
      title: 'Economics',
      responsable: 'Responsabile',
      type: 'Tipo trattamento',
      'start-date': 'Data stima inizio',
      'end-date': 'Data stima fine',
      cost: 'Costo atteso',
      'date-budget': 'Data inclusione budget'
    }
  },
  bowtieinterface: {
    titles: {
      projects: 'Progetti',
      approved: 'Approvati',
      gross: 'Analisi As Is',
      net: 'Analisi',
      analyze: 'Analizza',
      viewAnalysis: 'Vista analisi'
    },
    vincolaAttivita: 'Vincola attività',
    vincolaSubProcessi: 'Vincola sub-processi, attività',
    vincolaProcessi: 'Vincola processi, sub-processi, attività',
    source: 'Sorgente',
    preventive: 'Preventivo',
    responsive: 'Respositivo',
    consequences: 'Conseguenze',
    stage: 'Stage',
    add: 'Aggiungi',
    loading: 'Caricamento...',
    typeToLoad: 'Scrivi per i suggerimenti',
    changeState: 'Cambia stato',
    noItems: 'Nessun elemento',
    editOptions: 'Modifica opzioni',
    edit: 'Modifica',
    delete: 'Elimina',
    approved: 'Approvato',
    notApproved: 'Non approvato',
    notApplicable: 'Non applicabile',
    toBeApproved: 'Da approvare',
    selectStage: 'Scegli lo stage',
    applyLabel: 'Applica nel nodo corrente',
    confirmLabel: 'Conferma',
    note: 'Note',
    peso: 'Peso'
  },
  bia: {
    restorePlains: 'Piani di ripristino',
    addPlan: 'Aggiungi Piano di Ripristino',
    associatedPlan: 'Piano di Ripristino Associato',
    noAssociatedPlan: 'Nessun Piano di Ripristino Associato',
    chageStateError: 'Impossibile cambiare stato. Vincolo non rispettato per i seguenti processi:',
    nuovoProdottoServizio: 'Nuovo Prodotto/Servizio',
    cambioDiStato: 'Cambio di stato',
    selezionaProcesso: 'Seleziona il processo',
    tipo: 'Tipo',
    processes: 'Processi',
    process: 'Processo',
    subProcesses: 'Sotto processi',
    subProcess: 'Sotto processo',
    activity: 'Attività',
    subProcessesActivity: 'Sotto processi / Attività',
    subProcessActivity: 'Sotto processo / Attività',
    tools: 'Strumenti',
    'confirm-delete': 'Conferma elimination',
    'question-delete': 'Sei sicuro di voter cambiare eliminare l\'elemento?',
    'select-supplier': 'Seleziona il fornitore',
    associations: {
      procedure: 'Procedura',
      description: 'Descrizione'
    },
    warnings: {
      top: '',
      bottom: ''
    },
    supplierData: {
      selezionaAttrezzatura: 'Seleziona l\'attrezzatura',
      selezionaFornitore: 'Seleziona il fornitore',
      selezionaRisorsa: 'Seleziona una risorsa',
      nome: 'Nome',
      city: 'Città',
      selezionaFornitura: 'Seleziona fornitura',
      fornitura: 'Fornitura',
      livello: 'Livello',
      tipo: 'Tipo',
      nScorta: 'N. scorta',
      nFrequenza: 'N. freq',
      aumento: 'Aumento',
      impatto: 'Impatto',
      note: 'Note',
      bloccante: 'Bloccante',
      nuovaFornitura: 'Nuova fornitura',
      nuovaAttrezzatura: 'Nuova attrezzatura'
    },
    siti: {
      sito: 'Sito',
      nuovoSito: 'Nuovo sito',
      descrizione: 'Descrizione',
      cap: 'Cap',
      citta: 'Città',
      nomenclatura: 'Nomenclatura',
      paese: 'Paese',
      via: 'Via',
      unita: 'Unità'
    },
    personale: {
      nRisorseNecessarie: 'N. risorse necessarie',
      nRisorseEmergenza: 'N. risorse di emergenza',
      referente: 'Referente',
      risorseSostitute: 'Risorse sostitute',
      risorseEmergenza: 'Risorse in emergenza'
    },
    resource: {
      nome: 'Nome',
      cognome: 'Cognome',
      competenza: 'Competenza',
      telefonoPrincipale: 'Telefono principale',
      cellularePrincipale: 'Cellulare principale',
      emailPrincipale: 'Email principale',
      telefono: 'Telefono',
      cellulare: 'Cellulare',
      email: 'Email',
      lavoraDaRemoto: 'Lavora da remoto',
      interno: 'Interno'
    },
    timeClass: {
      a: 'Fino a 2 ore',
      b: '2 - 4 ore',
      c: '4 - 8 ore',
      d: '8 - 24 ore',
      e: '24 ore - 2 giorni',
      f: '2 giorni - 5 giorni',
      g: '5 giorni - 8 giorni',
      h: '8 giorni - 15 giorni',
      i: 'oltre 15 giorni'
    },
    volumesTab: {
      codice: 'Codice',
      nOperazioni: 'N. Operazioni',
      importoMedio: 'Importo medio',
      periodoRiferimento: 'Periodo di riferimento',
      tools: 'Strumenti',
      periodoUM: 'Periodo UM',
      nPeriodo: 'N. Periodo'
    },
    interdipTab: {
      stato: 'Stato',
      processoCritico: 'Processo Critico',
      processoNonCritico: 'Processo Non Critico',
      gradiInterdip: 'Gradi Interdip.',
      gradiInterdipendenza: 'Gradi di interdipendenza',
      descrizione: 'Descrizione',
      input: 'Input',
      output: 'Output',
      bloccante: 'Bloccante',
      tools: 'Strumenti',
      tempisticaBloccante: 'Tempistica bloccante',
      nBloccanti: 'N. bloccanti',
      note: 'Note'
    },
    'general-tab': {
      servizio: 'Servizio',
      prodotto: 'Prodotto',
      normative: 'Noramtiva',
      title: 'Titolo',
      state: 'Stato',
      'kind-of-impact': 'Tipo di impatto',
      'lock-sub-process-activity': 'Vincola sub-processi, attività',
      description: 'Descrizione',
      responsible: 'Responsabile',
      'sub-process-map': 'Mappa sotto processi',
      'activity-map': 'Mappa attività',
      normativity: 'Normative, vincoli contrattuali',
      mapping: 'Mappatura',
      'prodotto-servizio': 'Prodotto/Servizio'
    },
    supplierTab: {
      state: 'Stato',
      name: 'Nome',
      fornitura: 'Fornitura',
      livello: 'Livello',
      strumenti: 'Strumenti'
    },
    saveEntityError: 'Impossibile modificare lo stato. I seguenti campi vanno valorizzati: ',
    'not-indicated': 'In lavorazione',
    'not-compiled': 'Da non considerare',
    compiled: 'Approvato',
    completed: 'Completato',
    'not-completed': 'Non completato',
    compilation: 'Stato scheda',
    'show-more': 'Mostra di più',
    'emergency-resource': 'Risorsa di emergenza',
    'emergency-resources': 'Risorse di  emergenza',
    'regular-resources': 'Risorse essenziali',
    'backup-resource': 'Risorsa Sostituto',
    details: 'Dettagli',
    alarms: 'Allarmi',
    risks: 'Rischi',
    'IT-procedures': 'Procedure informatiche',
    equipments: 'Attrezzature',
    ricerca: 'Ricerca',
    'button-add': 'Aggiungi',
    'button-all': 'Tutti',
    'button-draft': 'Proposta',
    'button-compilation': 'Compilazione',
    'button-active': 'Attivo',
    'button-service': 'Servizio',
    'button-process': 'Processo',
    'button-under-process': 'Sotto processo',
    'button-activity': 'Attività',
    'no-subprecess-activity': 'Nessun sottoprocesso o attività',
    state: 'Stato',
    priority: 'Priorità',
    title: 'Titolo',
    'impact-type': 'Tipo impatto',
    general: 'Generale',
    'impact-evaluation': 'Valutazione impatto',
    attachments: 'Allegati',
    service: 'Servizio',
    cutoff: 'CutOff',
    cutoffPicco: 'CutOff e Periodi di Picco',
    'operating-volumes': 'Volumi operativi',
    interdependencies: 'Interdipendenze',
    'criticality-assessment': 'Valutazione criticità',
    providers: 'Fornitori',
    resources: 'Risorse',
    description: 'Descrizione',
    type: 'Tipo',
    time: 'Orario',
    periodicity: 'Periodicità',
    'no-respect': 'Conseguenze mancato rispetto',
    'note-no-respect': 'Note mancato rispetto',
    note: 'Note',
    supplier: 'Fornitore',
    'equipment-tab': {
      type: 'Tipo di attrezzatura',
      'qnt-normal': 'Quantità ordinaria',
      'qnt-min': 'Quantità minima',
      'exclusive-use': 'Uso esclusivo',
      'exclusive-use-type': 'tipo uso esclusivo',
      supplier: 'Fornitore',
      'supplier-backup': 'Fornitore di backup'
    },
    'cutoff-tab': {
      cutoff: 'Cutoff',
      peak: 'Picco',
      type: 'Tipo',
      time: 'Entro le',
      periodicity: 'Intervallo',
      quantity: 'Quantità',
      description: 'Descrizione',
      'note-missing-respect': 'Note mancato rispetto',
      'cons-missing-respect': 'Conseguenze mancato rispetto',
      'cons-missing-every': 'ogni'
    },
    'risks-tab': {
      description: 'Descrizione',
      name: 'Nome',
      attach: 'Allegato'
    },
    'it-tab': {
      name: 'Nome',
      description: 'Descrizione',
      'managed-by-company': 'Gestito internamente',
      reference: 'Referente procedura informatica',
      'select-reference-button': 'Seleziona il referente',
      'access-no-it': 'Accesso/elaborazione dati per via non informatica',
      kind: 'Tipologia',
      qnt: 'Quantità',
      time_to_restore: 'Tempo necessario al rirpistino',
      'backup-freq': 'Frequenza backup',
      'backup-procedure': 'Backup procedura gestito da azienda',
      'storage-media-type': 'Tipo di supporto di memorizzazione',
      'storage-media-position': 'Posizione del supporto di memorizzazione'
    },
    'impact-ev-tab': {
      'impact-value': 'Valore impatto',
      'ebita-value': 'Valore EBITA',
      'impact-metric': 'Metrica d\'impatto',
      'mdc-value': 'Valore % su MdC'
    },
    'process-tab': {
      index: 'Indice',
      description: 'Descrizione',
      impact: 'Impatti',
      tools: 'Strumenti'
    },
    'criticity-eval': {
      state: 'Stato',
      mtpd: 'MTPD',
      rto: 'RTO',
      Note: 'Note'
    }
  },
  metrics: {
    coefficenteRischio: 'Cofficente di rischio',
    giorniLavorativiAnno: 'Giorni lavorativi per anno',
    add: 'Aggiungi',
    totals: 'TOTALI',
    vociBilancio: 'Voci di bilancio',
    valore: 'Valore',
    percentuale: 'Minimo non eliminabile',
    importoPositivo: 'Importo positivo',
    importoNegativo: 'Importo negativo',
    dannoInterruzione: 'Danno da interruzione attività totale',
    dannoGiornalieroEvento: 'Danno giornaliero in caso di evento',
    impattoTollerabile: 'Impatto tollerabile'
  },
  adminRoles: {
    dettagli: 'Dettagli',
    moduli: 'Moduli',
    policies: 'Policies',
    add: 'Aggiungi',
    newRole: 'Nuovo ruolo',
    inputNewRoleCode: 'Inserisci il codice del ruolo',
    newRoleCode: 'Codice ruolo',
    roleCode: 'Codice ruolo',
    roleName: 'Nome ruolo',
    policy: {
      item: 'Item',
      desc: 'Descrizione'
    }
  },
  adminNodes: {
    dettagli: 'Dettagli',
    ruoli: 'Ruoli',
    svuota: 'Svuota',
    cleared: 'Svuotato',
    add: 'Aggiungi',
    newNode: 'Nuovo nodo',
    newRole: 'Nuovo ruolo',
    renameNode: 'Rinomina nodo',
    inputNewNodeCode: 'Inserisci il codice del nodo',
    newNodeCode: 'Codice nodo',
    'cleared-notification': 'Nodo svuotato',
    node: {
      id: 'Id',
      name: 'Nome',
      description: 'Descrizione',
      path: 'Path',
      code: 'Codice',
      tollerance: 'Tolleranza',
      appetite: 'Appetite',
      cbs: 'CBS'
    },
    roles: {
      id: 'Id',
      code: 'Codice',
      description: 'Descrizione'
    }
  },
  issues: {
    createCampaign: 'Nuova campagna',
    create: 'Nuova issue',
    title: 'Titolo',
    survey: 'Survey',
    mode: 'Accesso',
    target: 'Target',
    nodes: 'Nodi',
    state: 'Stato',
    situation: 'Situazione',
    actions: 'Azioni',
    tollerance: 'Tolleranza',
    appetite: 'Appetite',
    changeState: 'Cambia stato',
    prevDateStart: 'prevDateStart',
    prevDateEnd: 'prevDateEnd',
    effDateStart: 'effDateFrom',
    effDateEnd: 'effDateEnd'
  },
  monitors: {
    status: 'Stato',
    type: 'Tipo',
    origin: 'Origine',
    date: 'Data',
    actions: 'Azioni',
    next: 'Avanti',
    prev: 'Indietro',
    warning: 'Attenzione',
    requiredValues: 'Devi inserire tutti i valori richiesti'
  },
  plannings: {
    create: 'Crea',
    status: 'Stato',
    description: 'Descrizione',
    title: 'Titolo',
    addElement: 'Aggiungi attività',
    listElements: 'Lista attività',
    items: {
      element: 'Attività',
      title: 'Titolo',
      description: 'Descrizione',
      tabs: 'Tabs'
    },
    statusList: {
      draft: 'Bozza',
      approving: 'Approvazione',
      active: 'Attivo',
      all: 'Tutti'
    },
    associations: {
      associate: 'Associa',
      description: 'Descrizione',
      note: 'Note',
      associated: 'Associato',
      details: 'Dettagli associazione'
    },
    tabs: {
      general: 'Generale',
      attachments: 'Allegati',
      associations: 'Associazioni'
    }
  },
  surveys: {
    pageTitle: 'Surverys',
    create: 'Crea Survey',
    status: 'Stato',
    name: 'Nome',
    actions: 'Azioni',
    order: 'Ordinamento',
    answer: 'Risposta',
    ownerId: 'OwnerId',
    targetType: 'TargetType',
    targetId: 'TargetId',
    action: 'Azione',
    value: 'Valore',
    addSection: 'Aggiungi sezione',
    addQuestion: 'Aggiungi quesito',
    addAnswer: 'Aggiungi risposta',
    title: 'Title',
    moveUp: 'Sposta su',
    moveDown: 'Sposta giù',
    deleteSection: 'Elimina sezione',
    deleteQuestion: 'Elimina quesito'
  },
  esg: {
    issues: 'Issues',
    noIssues: 'Nessun problema rilevato',
    company: 'Azienda',
    dashboard: {
      state: 'Stato',
      companyName: 'Nome azienda',
      actions: 'Azioni',
      prog: 'Prog',
      validFrom: 'Valido dal',
      validTo: 'Valido al',
      reportEsg: 'Report ESG',
      reportMateriality: 'Report Materialità',
      advancedSearch: 'Ricerca avanzata',
      defaultAlerts: {
        issue: 'Informativa B1 - Base',
        kpi: '<p>Nella informativa B1 è stata selezionata la modalità base.</p>',
        label: 'Dossier senza Materialità',
      },
      defaultEmptyDossier: {
        issue: 'Nessun dossier attivo',
        kpi: '<p>Nessun dossier attivo</p>',
        label: 'Fornitore senza dossier'
      }
    },
    valuechain: {
      settore: 'Settore',
      geografico: 'Geografico',
      prodotto: 'Prodotto',
      aggiungiElemento: 'Aggiungi nuovo elemento',
      segModal: {
        title: 'Selettore scenario',
        S: 'S',
        E: 'E',
        G: 'G',
        scenario: 'Scenario',
        riskIndex: 'Indice di rischio',
        actions: 'Azioni'
      }
    },
    parts: {
      anagrafica: {
        header: 'Anagrafica Azienda',
        ateco: 'ATECO',
        descrizioneAttivita: 'Descrizione Attività',
        prodottiGestiti: 'Prodotti gestiti',
        aggiungiStruttura: 'Aggiungi struttura',
        generale: 'Generale',
        organiDiGoverno: 'Organi di Governo',
        note: 'Note',
        nome: 'Nome',
        cognome: 'Cognome',
        livelloReportisticaQuesito: 'A quale livello si intende eseguire l\'analisi e la consegna di reportistica?',
        strategyBusiness: 'Strategia: modello di business e iniziative legate alla sostenibilità',
        descrizioneGenerale: 'Descrizione generale',
        descrizioneTipologiaProdotti: 'Descrizione della tipologia di prodotti',
        indicazioneMercati: 'Indicazione dei mercati di operatività',
        settoreClientiMaggiori: 'Settore di appartenenza dei clienti maggiori',
        altro: 'Altro',
        strategySostenibility: 'Strategia in materia di sostenibilità',
        obiettiviAmbiente: 'Obiettivi - Ambiente',
        obiettiviSocial: 'Obiettivi - Social',
        obiettiviGovernance: 'Obiettivi - Governance',
        quesitoPoliticheImpattiAmbiente: 'Quali pratiche l\'azienda adotta o ha adottato con lo scopo di voler produrre impatti positivi sull\'ambiente, o sulle persone?',
        fatturato: 'Fatturato',
        capex: 'Capex',
        opex: 'Opex',
        export: 'Export',
        product: 'Prodotto',
        investimentiSostenibilita: 'Investimenti in sostenibilità',
        importo: 'Importo',
        reportEnergia: 'Reporting di informazioni in materia di consumo di energia e politiche in materia di combustibili fossili.',
        combustibiliFossili: 'Combustibili Fossili',
        energiaElettrica: 'Energia Elettrica',
        fonte: 'Fonte',
        rinnovabile: 'Rinnovabile',
        emissioniGhg: 'Emissioni di GHG',
        scope1: 'Scope 1',
        scope2: 'Scope 2',
        obiettiviRiduzione: 'Obiettivi di Riduzione',
        tipologiaInquinante: 'Tipologia inquinante',
        quantitaAnno: 'Quantità/anno',
        struttura: 'Struttura',
        luogo: 'Luogo',
        nessunElementoInquinanti: 'Nessun elemento da visualizzare in quanto non sono state aggiunte Emissioni Inquinanti nella sezione "Emissioni di altri inquinanti in acque, atmosfera o nel suolo" delle strutture',
        biodiversita: 'Biodiversità',
        totaleSuperficieProduttiva: 'Totale superficie area produttiva aziendale',
        destinataProduzione: 'Destinata alla produzione',
        tipologiaDestinazione: 'Tipologia Destinazione',
        prioritaAffitto: 'Priorità/Affitto',
        lasciataNaturale: 'Lasciata naturale o area verde',
        areaSostenibileOBiodiversitaQuesito: 'Area sensibile a Biodiversità?',
        risorseIdriche: 'Risorse Idriche',
        qntAcquaUtilizzataPerCiclo: 'Quantità di acqua utilizzata dal ciclo produttivo totale',
        daAcquedotto: 'Da acquedotto',
        daPozzo: 'Da pozzo',
        daAltreSorgive: 'Da altre aree sorgenti',
        sullaBaseDi: 'Sulla base di',
        usoDelleRisorseEconomicaCircolare: 'Uso delle risorse ed economica circolare',
        contenutoProdottoRiciclato: 'Contenuto di prodotto riciclato',
        contenutoProdottoRiciclabile: 'Contenuto di prodotto riciclabile',
        prodottiFiniti: 'Prodotti finiti',
        um: 'UM',
        imballaggi: 'Imballaggi',
        rifiuti: 'Rifiuti',
        produzioneTotaleRifiuti: 'Produzione totale rifiuti',
        pericolosi: 'Pericolosi',
        nonPericolosi: 'Non pericolosi',
        diCuiRicilcabili: 'Di cui riciclabili',
        diCuiDestinatiRiuso: 'Di cui destinati al riuso',
        forzaLavoro: 'Forza lavoro',
        dettagli: 'Dettagli',
        nTotale: 'N° Totale',
        totale: 'Totale',
        uomini: 'Uomini',
        donne: 'Donne',
        nazione: 'Nazione',
        ccnlApplicato: 'CCNL Applicato',
        dipendenti: 'Dipendenti',
        tempoIndeterminato: 'Di cui a tempo indeteminato',
        tempoDeterminato: 'Di cui a tempo determinato',
        totaleOreLavorate: 'Totale ore lavorate',
        totaleOreFormazione: 'Totale Ore Formazione Erogate',
        mediaLivelloRetributivo: 'Media Livello retributivo orario applicato',
        totaleInfortuni: 'Totale Infortuni',
        totaleDecessi: 'Totale Decessi',
        totaleOreMalattie: 'Totale Ore Malattie professionali',
        dipendentiConContrattiCollettivi: 'Dipendenti coperti da contratti collettivi di lavoro',
        differenzialeSalari: 'Differenziale tra salari minimi e salari erogati',
        seOltre150Dipendenti: 'se più di 150 dipendenti',
        condanneCorruzione: 'Condanne per reati legati alla corruzione',
        location: 'Location',
        prodotto: 'Prodotto',
        energiaElettricaRinnovabili: 'Energia elettrica da fonti rinnovabili',
        energiaElettricaNonRinnovabili: 'Energia elettrica da fonti non rinnovabili',
        emissioniInquinantiInAcqueAtmosfereSuolo: 'Emissioni di altri inquinanti in acque, atmosfera o nel suolo',
        nessunInquinante: 'Nessun inquinante',
        quantita: 'Quantità',
        consumoTerritorio: 'Consumo territorio',
        superficieAreaProduttivaAziendale: 'Superficie area produttiva aziendale',
        destinataAllaProduzione: 'Destinata alla produzione',
        consumoIdrico: 'Consumo idrico',
        usoRisorseEconomicaCircolare: 'Uso delle risorse ed economica circolare',
        nazionalita: 'Nazionalità',
        tassoInfortuni: 'Tasso infortuni',
        informativaB1: 'Informativa B.1',
        informativaB2: 'Informativa B.2',
        informativaB3: 'Informativa B.3',
        informativaB4: 'Informativa B.4',
        informativaB5: 'Informativa B.5',
        informativaB6: 'Informativa B.6',
        informativaB7: 'Informativa B.7',
        informativaB8_8_10: 'Informativa B.8 - B.9 - B.10',
        informativaB11: 'Informativa B.11',
        certificazioniOttenuteModelliAdottati: 'Certificazioni ottenute e modelli di gestione adottati',
        lista: 'Lista',
        genere: 'Genere',
        tipo: 'Tipo',
        sito: 'Sito',
        processo: 'Processo',
      },
      maturity: {
        tabN: 'Generale',
        tabE: 'Environment',
        tabS: 'Social',
        tabG: 'Governance',
        attenzione: 'Attenzione',
        noDossierLine1: 'Non sono presenti maturità per questo dossier.',
        noDossierLine2: 'Compilali nella sezione di modifica per continuare.',
        vaiAllaModifica: 'Vai alla modifica',
        nota: 'Nota',
      },
      presurvey: {
        attenzione: 'Attenzione',
        noDataLine1: 'Non sono presenti dati per questo dossier.',
        noDataLine2: 'Compilali nella sezione di modifica per continuare.',
        vaiAllaModifica: 'Vai alla modifica',
        note: 'Note',
      },
      dossier: {
        issues: 'Issues',
        attenzione: 'Attenzione',
        noDataLine1: 'Non sono presenti dati per questo dossier.',
        noDataLine2: 'Compilali nella sezione di modifica per continuare.',
        vaiAllaSezioneAnagrafica: 'Vai alla sezione Anagrafiche',
        prodotti: 'Prodotti',
        descrizione: 'Descrizione',
        localizzazione: 'Localizzazione',
        nStabilimenti: 'N. stabilimenti',
        indirizzo: 'Indirizzo',
        eligTassonomiaAmbientale: 'Eligibilità per la Tassonomia Ambientale',
        dnshCompilant: 'DNSH Compliant',
        techScreeningCompilnat: 'Technical Screening Compliant',
        titolo: 'Titolo',
        location: 'Location',
        prodotto: 'Prodotto',
      },
      valutation: {
        issues: 'Issues',
        attenzione: 'Attenzione',
        noDataLine1: 'Non sono presenti dati per questo dossier.',
        noDataLine2: 'Compilali nella sezione Value Chain per continuare.',
        vaiAllaValueChain: 'Vai alla sezione Value Chain',
        valutazione: 'Valutazione',
        senzaNome: 'No name',
      },
      report: {
        dossier: 'Dossier',
        attenzione: 'Attenzione',
        noDataLine1: 'Non sono presenti scenari per questo dossier.',
        noDataLine2: 'Compilali nella sezione Value Chain per continuare.',
        vaiAllaValueChain: 'Vai alla sezione Value Chain',

        tabE: 'Environment',
        tabS: 'Social',
        tabG: 'Governance',
        senzaNome: 'No name',
        materialitaMessaggio: 'Sulla base della metodologia applicata per l\'analisi di materialità volta a definire quali siano le questioni che per impatto o rilevanza finanziaria sia necessario rendicontare,\n' +
          '                la presente questione di sostenibilità è da intendersi non rilevante e, pertanto, non vengono forniti ulteriori dettagli.',

      }
    },
    noData: 'Nessun dato',
    dossierForm: {
      validoDal: 'Valido dal',
      validoAl: 'Valido al',
      stato: 'Stato',
      descrizione: 'Descrizione',
      azioni: 'Azioni',
    }
  },
  lookup: {
    code: 'Codice',
    parent: 'Padre',
    name: 'Nome',
    note: 'Note',
    description: 'Descrizione'
  },
  Home: 'Home',
  Statistiche: 'Statistiche',
  Rischi: 'Rischi',
  'Analisi As Is': 'Analisi As Is',
  Trattamenti: 'Trattamenti',
  Analisi: 'Analisi',
  'Business Continuity': 'Business Continuity',
  'Amministrazione Aziendale': 'Amministrazione Aziendale',
  Fornitori: 'Fornitori',
  'Volumi Minimi': 'Volumi Minimi',
  Cutoff: 'Cutoff',
  Interdipendenze: 'Interdipendenze',
  'Impatto Operativo': 'Impatto Operativo',
  'Impatto Reputazionale': 'Impatto Reputazionale',
  'Impatto Normativo': 'Impatto Normativo',
  'Impatto Economico': 'Impatto Economico',
  Personale: 'Personale',
  budget: {
    noBudget: 'Senza budget',
    ereditato: 'Ereditato',
    validoDal: 'Valido dal'
  },
  ITEM_GROUP_LOCAL: 'Impostazioni locali: @@node@@',
  ITEM_BUDGET: 'Valori di Bilancio',
  ITEM_GROUP_ENTERPRISE: 'Impostazioni azienda',
  ITEM_IMPORT_RISK: 'Import Rischi',
  ITEM_MANAGE_NODES: 'Gestione Risk Architecture',
  ITEM_MANAGE_ROLES: 'Gestione Ruoli',
  ITEM_ENROLL: 'Iscrizione utente/rolo',
  'admin-settings': {
    'local-settings': 'Impostazioni locali: @@node@@',
    budget: 'Valori di Bilancio',
    budgetForm: {
      nuovoBudget: 'Nuovi Valori di Bilancio',
      eredita: 'Eredita',
      situazioneAttuale: 'Situazione attuale',
      listaBudget: 'Elenco Valori di Bilancio',
      data: 'Data',
      stato: 'Stato',
      actions: 'Azioni',
      impatto: 'Danno interruzione',
      impactDay: 'Danno giornaliero'
    }
  },
  graphs: {
    area: 'Area',
    category: 'Categoria',
    company: 'Azienda',
    period: 'Periodo',
    causa: 'Causa',
    effetto: 'Effetto'
  },
  chat: {
    'new-message': 'Nuovo messaggio'
  },
  attachments: {
    document: 'Documento',
    user: 'Utente',
    'date-time': 'Data e ora',
    attachment: 'Allegato',
    'no-attachment': 'Nessun Allegato',
    upload: 'Trascina qui'
  }
};
